import { Typography } from '@kustom-checkout/morpheus';

import { SHIPPING_MODULE_VERSION } from '~/lib/version';

interface DebugPanelProps {
  kssSessionId?: string;
  serviceVersion?: string;
}

export function DebugPanel({ kssSessionId, serviceVersion }: DebugPanelProps) {
  const rows = [
    { label: 'Session ID', value: kssSessionId || '-' },
    { label: 'Back end version', value: serviceVersion || '-' },
    { label: 'Front end version', value: SHIPPING_MODULE_VERSION },
  ];

  return (
    <div className="flex flex-col gap-1">
      {rows.map(({ label, value }) => (
        <Typography key={label} variant="xSmall" color="muted">
          <strong>{label}:</strong> {value}
        </Typography>
      ))}
    </div>
  );
}
